var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHelpFilledIcon = function SvgHelpFilledIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0.5C10.304 0.5 0 10.804 0 23.5C0 36.196 10.304 46.5 23 46.5C35.696 46.5 46 36.196 46 23.5C46 10.804 35.696 0.5 23 0.5ZM25.3 39.6H20.7V35H25.3V39.6ZM30.061 21.775L27.991 23.891C26.335 25.57 25.3 26.95 25.3 30.4H20.7V29.25C20.7 26.72 21.735 24.42 23.391 22.741L26.243 19.843C27.094 19.015 27.6 17.865 27.6 16.6C27.6 14.07 25.53 12 23 12C20.47 12 18.4 14.07 18.4 16.6H13.8C13.8 11.517 17.917 7.4 23 7.4C28.083 7.4 32.2 11.517 32.2 16.6C32.2 18.624 31.372 20.464 30.061 21.775Z",
    fill: "#2E0DA6"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHelpFilledIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "help-filled-icon.9cd086e2909d41b7c7aead854d866cdb.svg";